(function () {
  'use strict';

  // These small, side-effect-free helpers are also available to local checks.
  function aggregateSelections(selectedIds) {
    var totals = new Map();
    selectedIds.forEach(function (id) {
      if (id !== null && id !== undefined && id !== '') {
        var key = Number(id);
        totals.set(key, (totals.get(key) || 0) + 1);
      }
    });
    return Array.from(totals, function (entry) { return { id: entry[0], quantity: entry[1] }; });
  }

  function itemLabel(item) {
    var title = String(item.title || '').trim();
    var vendor = String(item.vendor || '').trim();
    return vendor && !title.toLocaleLowerCase().startsWith(vendor.toLocaleLowerCase()) ? vendor + ' · ' + title : title;
  }

  function normaliseGreeting(value) {
    return String(value || '').replace(/[\r\n]+/g, ' ');
  }

  function selectedTotal(selectedIds, catalog, packagingPrice) {
    var byId = new Map(catalog.map(function (item) { return [Number(item.id), item]; }));
    return selectedIds.reduce(function (sum, id) {
      var item = byId.get(Number(id));
      return sum + (item ? Number(item.price) : 0);
    }, Number(packagingPrice) || 0);
  }

  function validateStock(selectedIds, catalog, cartItems) {
    var byId = new Map(catalog.map(function (item) { return [Number(item.id), item]; }));
    var existing = new Map();
    (cartItems || []).forEach(function (item) {
      var id = Number(item.variant_id || item.id);
      existing.set(id, (existing.get(id) || 0) + Number(item.quantity || 0));
    });
    return aggregateSelections(selectedIds).reduce(function (errors, selection) {
      var item = byId.get(selection.id);
      if (!item || !item.available) {
        errors.push({ code: 'unavailable_error', id: selection.id, title: item ? item.title : '' });
      } else if (item.maxQuantity !== null && item.maxQuantity !== undefined && selection.quantity + (existing.get(selection.id) || 0) > Number(item.maxQuantity)) {
        errors.push({ code: 'stock_error', id: selection.id, title: item.title, available: Math.max(0, Number(item.maxQuantity) - (existing.get(selection.id) || 0)) });
      }
      return errors;
    }, []);
  }

  function verifyGroup(cartItems, group, expected) {
    var lines = (cartItems || []).filter(function (item) { return item.properties && item.properties._mirjo_giftbox_group === group; });
    var parents = lines.filter(function (item) { return item.properties._mirjo_giftbox_role === 'packaging'; });
    var children = lines.filter(function (item) { return item.properties._mirjo_giftbox_role === 'sample'; });
    if (parents.length !== 1 || Number(parents[0].quantity) !== 1 || lines.length !== parents.length + children.length) return false;
    if (!parents[0].key || children.some(function (item) { return !item.parent_relationship || item.parent_relationship.parent_key !== parents[0].key; })) return false;
    var actual = new Map();
    children.forEach(function (item) {
      var id = Number(item.variant_id || item.id);
      actual.set(id, (actual.get(id) || 0) + Number(item.quantity));
    });
    return actual.size === expected.length && expected.every(function (item) { return actual.get(item.id) === item.quantity; });
  }

  var helpers = { aggregateSelections: aggregateSelections, selectedTotal: selectedTotal, validateStock: validateStock, verifyGroup: verifyGroup, itemLabel: itemLabel, normaliseGreeting: normaliseGreeting };
  if (typeof module !== 'undefined' && module.exports) module.exports = helpers;
  if (typeof window === 'undefined' || typeof document === 'undefined') return;
  window.MirjoGiftboxHelpers = helpers;

  function Giftbox(element) {
    this.element = element;
    this.form = element.querySelector('[data-giftbox-form]');
    this.root = (element.dataset.root || '/').replace(/\/?$/, '/');
    this.i18n = JSON.parse(element.querySelector('[data-giftbox-i18n]').textContent);
    this.packagingId = Number(element.dataset.packagingId);
    this.packagingPrice = Number(element.dataset.packagingPrice) || 1500;
    this.previewOnly = element.dataset.previewOnly === 'true';
    this.packagingAvailable = !this.previewOnly && element.dataset.packagingAvailable === 'true';
    this.packagingHandle = element.dataset.packagingHandle;
    this.catalog = [];
    this.catalogMap = new Map();
    this.selectedIds = [null, null, null, null];
    this.count = 3;
    this.loaded = false;
    this.loading = false;
    this.busy = false;
    this.personalisationFits = true;
    this.personalisationFitCache = new WeakMap();
    this.numberFormat = new Intl.NumberFormat(element.dataset.locale || 'de-CH', { style: 'currency', currency: element.dataset.currency || 'CHF' });
    this.slots = Array.from(element.querySelectorAll('[data-slot]'));
    this.bind();
    if (typeof ResizeObserver !== 'undefined') {
      this.previewResizeObserver = new ResizeObserver(this.checkPersonalisationFit.bind(this));
      this.element.querySelectorAll('.mj-giftbox__band, [data-preview-back-band]').forEach(function (band) {
        this.previewResizeObserver.observe(band);
      }, this);
    }
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(function () {
        this.personalisationFitCache = new WeakMap();
        this.checkPersonalisationFit();
      }.bind(this));
    }
    this.renderSummary();
    this.load();
  }

  Giftbox.prototype.t = function (key, values) {
    var text = this.i18n[key] || key;
    Object.keys(values || {}).forEach(function (name) { text = text.split('{' + name + '}').join(String(values[name])); });
    return text;
  };

  Giftbox.prototype.money = function (cents) { return this.numberFormat.format(Number(cents) / 100); };
  Giftbox.prototype.query = function (selector) { return this.element.querySelector(selector); };
  Giftbox.prototype.activeIds = function () { return this.selectedIds.slice(0, this.count); };
  Giftbox.prototype.itemLabel = itemLabel;

  Giftbox.prototype.bind = function () {
    var self = this;
    this.form.addEventListener('submit', function (event) { event.preventDefault(); self.addToCart(); });
    this.element.querySelectorAll('input[name^="giftbox-size-"]').forEach(function (radio) {
      radio.addEventListener('change', function () {
        if (!radio.checked) return;
        self.count = Number(radio.value);
        self.slots.forEach(function (slot, index) { slot.hidden = index >= self.count; });
        self.renderSummary();
        self.renderPersonalisation();
      });
    });
    this.slots.forEach(function (slot, index) {
      var search = slot.querySelector('[data-slot-search]');
      search.addEventListener('input', function () { self.renderOptions(index); });
      search.addEventListener('keydown', function (event) { if (event.key === 'Enter' && !event.isComposing) event.preventDefault(); });
      slot.querySelector('[data-slot-select]').addEventListener('change', function (event) {
        self.selectedIds[index] = event.target.value ? Number(event.target.value) : null;
        self.renderSlot(index);
        self.renderSummary();
        self.setStatus('');
      });
      slot.querySelector('[data-slot-clear]').addEventListener('click', function () {
        self.selectedIds[index] = null;
        slot.querySelector('[data-slot-search]').value = '';
        self.renderSlot(index);
        self.renderOptions(index);
        self.renderSummary();
        slot.querySelector('[data-slot-search]').focus();
      });
    });
    this.query('[data-catalog-retry]').addEventListener('click', function () { self.load(); });
    this.element.querySelectorAll('input[name^="giftbox-colour-"], [data-giftbox-title], [data-giftbox-name], [data-giftbox-message], [data-giftbox-back-message]').forEach(function (input) {
      input.addEventListener('input', function () { self.renderPersonalisation(); });
      input.addEventListener('change', function () { self.renderPersonalisation(); });
    });
    this.element.querySelectorAll('[data-preview-view]').forEach(function (button) {
      button.addEventListener('click', function () {
        self.query('.mj-giftbox__preview').dataset.previewMode = button.dataset.previewView;
        self.element.querySelectorAll('[data-preview-view]').forEach(function (item) { item.setAttribute('aria-pressed', String(item === button)); });
        self.checkPersonalisationFit();
      });
    });
    this.renderPersonalisation();
  };

  Giftbox.prototype.requestJSON = async function (path, options) {
    var response = await fetch(path, Object.assign({ credentials: 'same-origin', cache: 'no-store', headers: { 'Accept': 'application/json' } }, options || {}));
    if (!response.ok) throw new Error('add_error');
    return response.json();
  };

  Giftbox.prototype.postJSON = function (path, body) {
    return this.requestJSON(this.root + path, { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify(body) });
  };

  Giftbox.prototype.fetchCatalog = async function () {
    var next = this.root + 'collections/all?section_id=mirjo-giftbox-catalog&page=1';
    var seen = new Set();
    var items = new Map();
    while (next) {
      var url = new URL(next, window.location.origin);
      if (url.origin !== window.location.origin) throw new Error('loading_error');
      url.searchParams.set('section_id', 'mirjo-giftbox-catalog');
      var pageKey = url.pathname + url.search;
      if (seen.has(pageKey)) throw new Error('loading_error');
      seen.add(pageKey);
      var response = await fetch(url.toString(), { credentials: 'same-origin', cache: 'no-store', headers: { 'Accept': 'text/html' } });
      if (!response.ok) throw new Error('loading_error');
      var html = new DOMParser().parseFromString(await response.text(), 'text/html');
      var script = html.querySelector('script[data-mirjo-giftbox-catalog]');
      if (!script) throw new Error('loading_error');
      var data = JSON.parse(script.textContent);
      if (!Array.isArray(data.items)) throw new Error('loading_error');
      data.items.forEach(function (item) {
        if (Number.isSafeInteger(Number(item.id)) && Number.isFinite(Number(item.price)) && Number(item.price) >= 0 && item.available && (item.maxQuantity === null || item.maxQuantity === undefined || Number(item.maxQuantity) > 0)) {
          items.set(Number(item.id), Object.assign({}, item, { id: Number(item.id), price: Number(item.price) }));
        }
      });
      next = data.next ? new URL(data.next, url).toString() : null;
    }
    var locale = this.element.dataset.locale;
    return Array.from(items.values()).sort(function (a, b) { return ((a.vendor || '') + ' ' + a.title).localeCompare((b.vendor || '') + ' ' + b.title, locale, { sensitivity: 'base' }); });
  };

  Giftbox.prototype.fetchPackaging = async function () {
    if (!this.packagingHandle) throw new Error('box_unavailable');
    var product = await this.requestJSON(this.root + 'products/' + encodeURIComponent(this.packagingHandle) + '.js');
    var variant = product.variants.find(function (item) { return Number(item.id) === this.packagingId; }, this);
    if (!variant || !variant.available) throw new Error('box_unavailable');
    return variant;
  };

  Giftbox.prototype.applyCatalog = function (catalog) {
    this.catalog = catalog;
    this.catalogMap = new Map(catalog.map(function (item) { return [item.id, item]; }));
    this.selectedIds = this.selectedIds.map(function (id) { return this.catalogMap.has(id) ? id : null; }, this);
    this.loaded = true;
    this.slots.forEach(function (slot, index) { this.renderOptions(index); this.renderSlot(index); }, this);
    this.query('[data-catalog-status]').textContent = catalog.length ? this.t('catalog_ready', { count: catalog.length }) : this.t('empty_catalog');
    this.renderSummary();
  };

  Giftbox.prototype.load = async function () {
    if (this.loading || this.busy) return;
    this.loading = true;
    this.query('[data-catalog-status]').textContent = this.t('loading');
    this.query('[data-catalog-retry]').hidden = true;
    try {
      this.applyCatalog(await this.fetchCatalog());
    } catch (error) {
      this.query('[data-catalog-status]').textContent = this.t('loading_error');
      this.query('[data-catalog-retry]').hidden = false;
    } finally {
      this.loading = false;
      this.renderSummary();
    }
  };

  Giftbox.prototype.renderOptions = function (index) {
    var slot = this.slots[index];
    var input = slot.querySelector('[data-slot-search]');
    var select = slot.querySelector('[data-slot-select]');
    var normalize = function (text) { return String(text).normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLocaleLowerCase(); };
    var query = normalize(input.value.trim());
    var self = this;
    var matches = this.catalog.filter(function (item) { return normalize(self.itemLabel(item)).includes(query); });
    var options = document.createDocumentFragment();
    var placeholder = document.createElement('option');
    placeholder.value = '';
    placeholder.textContent = this.t('choose_fragrance');
    options.appendChild(placeholder);
    var chosen = this.catalogMap.get(this.selectedIds[index]);
    var displayed = matches.slice();
    if (chosen && !matches.some(function (item) { return item.id === chosen.id; })) displayed.unshift(chosen);
    displayed.forEach(function (item) {
      var option = document.createElement('option');
      option.value = String(item.id);
      option.textContent = self.itemLabel(item) + ' · ' + self.money(item.price);
      options.appendChild(option);
    });
    select.replaceChildren(options);
    select.value = this.selectedIds[index] ? String(this.selectedIds[index]) : '';
    select.disabled = !this.loaded || this.busy || !this.catalog.length;
    input.disabled = !this.loaded || this.busy || !this.catalog.length;
    slot.querySelector('[data-slot-results]').textContent = matches.length ? this.t('match_count', { count: matches.length }) : this.t('no_results');
  };

  Giftbox.prototype.renderSlot = function (index) {
    var slot = this.slots[index];
    var item = this.catalogMap.get(this.selectedIds[index]);
    slot.dataset.selected = String(Boolean(item));
    slot.querySelector('[data-slot-title]').textContent = item ? this.itemLabel(item) : this.t('choose_fragrance');
    slot.querySelector('[data-slot-price]').textContent = item ? this.money(item.price) : '';
    slot.querySelector('[data-slot-clear]').hidden = !item;
    slot.querySelector('[data-slot-select]').value = item ? String(item.id) : '';
  };

  Giftbox.prototype.renderSummary = function () {
    var selected = this.activeIds();
    var filled = selected.filter(function (id) { return this.catalogMap.has(id); }, this).length;
    var ready = filled === this.count && this.loaded && this.packagingAvailable && Boolean(this.packagingId);
    var progress = this.query('[data-selection-progress]');
    progress.textContent = ready ? this.t('ready') : this.t('progress', { selected: filled, count: this.count });
    progress.dataset.complete = String(ready);
    var total = selectedTotal(selected, this.catalog, this.packagingPrice);
    this.query('[data-packaging-total]').textContent = this.money(this.packagingPrice);
    this.query('[data-samples-total]').textContent = filled ? this.money(total - this.packagingPrice) : '—';
    this.query('[data-giftbox-total]').textContent = this.money(total);
    var button = this.query('[data-giftbox-add]');
    var titleProvided = this.hasPersonalisationTitle();
    button.disabled = !ready || !titleProvided || !this.personalisationFits || this.busy || this.loading;
    button.firstChild.textContent = this.t(this.busy ? 'adding' : 'add');
    this.query('.mj-giftbox__preview').dataset.previewCount = String(this.count);
    this.renderChosenPreview();
    if (this.previewOnly) this.setStatus(this.t('preview_notice'));
    else if (!this.packagingAvailable || !this.packagingId) this.setStatus(this.t('box_unavailable'), true);
    this.updateTitleRequirement(titleProvided);
  };

  Giftbox.prototype.renderChosenPreview = function () {
    var container = this.query('[data-chosen-preview]');
    container.replaceChildren();
    var selected = this.activeIds().map(function (id) { return this.catalogMap.get(id); }, this);
    if (!selected.some(Boolean)) return;
    var heading = document.createElement('h3');
    heading.textContent = this.t('selected_scents');
    var list = document.createElement('ol');
    list.className = 'mj-giftbox__chosen-list';
    selected.forEach(function (item, index) {
      if (!item) return;
      var row = document.createElement('li');
      if (item.image) {
        var image = document.createElement('img');
        image.src = item.image;
        image.alt = '';
        image.width = 38;
        image.height = 44;
        image.loading = 'lazy';
        row.appendChild(image);
      }
      var copy = document.createElement('div');
      var label = document.createElement('small');
      label.textContent = this.t('slot_label', { number: index + 1 }) + ' · 3 ml';
      var name = document.createElement('strong');
      name.textContent = this.itemLabel(item);
      copy.append(label, name);
      row.appendChild(copy);
      list.appendChild(row);
    }, this);
    container.append(heading, list);
  };

  Giftbox.prototype.personalisation = function () {
    var title = this.query('[data-giftbox-title]');
    var back = this.query('[data-giftbox-back-message]');
    return {
      colour: this.query('input[name^="giftbox-colour-"]:checked').value,
      template: 'custom',
      title: title ? title.value : '',
      name: this.query('[data-giftbox-name]').value,
      message: this.query('[data-giftbox-message]').value,
      backMessage: back ? back.value : ''
    };
  };

  Giftbox.prototype.hasPersonalisationTitle = function () {
    var title = this.query('[data-giftbox-title]');
    return !!title && String(title.value || '').trim().length > 0;
  };

  Giftbox.prototype.updateTitleRequirement = function (provided) {
    var title = this.query('[data-giftbox-title]');
    var message = this.t('title_required');
    if (title) {
      if (provided) title.removeAttribute('aria-invalid');
      else title.setAttribute('aria-invalid', 'true');
      if (typeof title.setCustomValidity === 'function') title.setCustomValidity(provided ? '' : message);
    }
    var hint = this.query('[data-title-required-message]');
    if (hint) {
      hint.textContent = message;
      hint.hidden = provided;
    } else {
      var status = this.query('[data-checkout-status]');
      if (!provided && !this.previewOnly && this.packagingAvailable) {
        this.setStatus(message);
        if (status) status.dataset.titleRequired = 'true';
      } else if (provided && status && status.dataset.titleRequired === 'true') {
        this.setStatus('');
        delete status.dataset.titleRequired;
      }
    }
  };

  Giftbox.prototype.renderPersonalisation = function () {
    var value = this.personalisation();
    this.query('.mj-giftbox__preview').dataset.previewColour = value.colour;
    this.query('[data-preview-template]').textContent = value.title;
    this.query('[data-preview-name]').textContent = value.name;
    this.query('[data-preview-message]').textContent = value.message;
    var backPreview = this.query('[data-preview-back-message]');
    if (backPreview) backPreview.textContent = value.backMessage;
    var titleCount = this.query('[data-title-count]');
    if (titleCount) titleCount.textContent = value.title.length + ' / 48';
    this.query('[data-message-count]').textContent = value.message.length + ' / 220';
    var backCount = this.query('[data-back-message-count]');
    if (backCount) backCount.textContent = value.backMessage.length + ' / 220';
    this.checkPersonalisationFit();
    this.renderSummary();
  };

  Giftbox.prototype.checkPersonalisationFit = function () {
    if (this.fittingPersonalisation) return;
    this.fittingPersonalisation = true;
    if (!this.personalisationFitCache) this.personalisationFitCache = new WeakMap();
    var fits = true;
    var self = this;
    var surfaces = Array.from(this.element.querySelectorAll('.mj-giftbox__band, [data-preview-back-band]'));
    function surfaceFits(band) {
      return [band].concat(Array.from(band.children)).every(function (item) {
        // Hidden or inline nodes have no measurable box and cannot demonstrate overflow.
        if (!item.clientWidth || !item.clientHeight) return true;
        return item.scrollHeight <= item.clientHeight + 1 && item.scrollWidth <= item.clientWidth + 1;
      });
    }
    try {
      surfaces.forEach(function (band) {
        // A hidden alternate face must never disable purchasing because its layout is zero.
        if (!band.clientWidth || !band.clientHeight) return;
        var signature = [band.clientWidth, band.clientHeight, window.innerWidth, band.textContent].join('|');
        var cached = self.personalisationFitCache.get(band);
        if (cached && cached.signature === signature) { fits = fits && cached.fits; return; }
        band.style.setProperty('--mj-personalisation-fit', '1');
        var bandFits = surfaceFits(band);
        if (!bandFits) {
          // Both faces scale independently. Every entered character stays in textContent.
          var minimum = 0.45;
          var low = minimum;
          var high = 1;
          band.style.setProperty('--mj-personalisation-fit', String(minimum));
          bandFits = surfaceFits(band);
          if (bandFits) {
            for (var attempt = 0; attempt < 8; attempt++) {
              var candidate = (low + high) / 2;
              band.style.setProperty('--mj-personalisation-fit', String(candidate));
              if (surfaceFits(band)) low = candidate;
              else high = candidate;
            }
            band.style.setProperty('--mj-personalisation-fit', String(low));
          }
        }
        self.personalisationFitCache.set(band, { signature: signature, fits: bandFits });
        fits = fits && bandFits;
      });
      var error = this.query('[data-personalisation-error]');
      if (error) error.hidden = fits;
    } finally {
      this.fittingPersonalisation = false;
    }
    if (this.personalisationFits !== fits) {
      this.personalisationFits = fits;
      this.renderSummary();
    }
  };

  Giftbox.prototype.setStatus = function (text, error) {
    var status = this.query('[data-checkout-status]');
    status.textContent = text;
    status.dataset.error = String(Boolean(error));
  };

  Giftbox.prototype.setBusy = function (busy) {
    this.busy = busy;
    this.form.setAttribute('aria-busy', String(busy));
    this.form.querySelectorAll('input, select, textarea, button').forEach(function (input) { input.disabled = busy; });
    this.slots.forEach(function (slot, index) { this.renderOptions(index); }, this);
    this.renderSummary();
  };

  Giftbox.prototype.removeGroup = async function (group, knownKey) {
    var cart = await this.requestJSON(this.root + 'cart.js');
    var lines = cart.items.filter(function (item) { return item.properties && item.properties._mirjo_giftbox_group === group; });
    var parent = lines.find(function (item) { return item.properties._mirjo_giftbox_role === 'packaging'; });
    if (parent) {
      await this.postJSON('cart/change.js', { id: parent.key, quantity: 0 });
    } else if (knownKey && cart.items.some(function (item) { return item.key === knownKey; })) {
      await this.postJSON('cart/change.js', { id: knownKey, quantity: 0 });
    }
    cart = await this.requestJSON(this.root + 'cart.js');
    // A defensive cleanup covers an interrupted or partially accepted add.
    var leftovers = cart.items.filter(function (item) { return item.properties && item.properties._mirjo_giftbox_group === group; });
    for (var item of leftovers) await this.postJSON('cart/change.js', { id: item.key, quantity: 0 });
    if (leftovers.length) cart = await this.requestJSON(this.root + 'cart.js');
    if (cart.items.some(function (item) { return item.key === knownKey || (item.properties && item.properties._mirjo_giftbox_group === group); })) throw new Error('rollback_error');
  };

  Giftbox.prototype.invalidateCartGuard = function () {
    var guard = window.MirjoGiftboxCart;
    if (guard && typeof guard.invalidate === 'function') guard.invalidate();
    document.dispatchEvent(new CustomEvent('mirjo:giftbox:cart-updated'));
  };

  Giftbox.prototype.addToCart = async function () {
    if (this.previewOnly || !this.personalisationFits || this.busy || this.loading || !this.loaded || this.activeIds().some(function (id) { return id === null; })) return;
    if (!this.hasPersonalisationTitle()) {
      this.updateTitleRequirement(false);
      var titleInput = this.query('[data-giftbox-title]');
      if (titleInput) titleInput.focus();
      return;
    }
    var ids = this.activeIds().slice();
    var personalisation = this.personalisation();
    var previousPrices = ids.map(function (id) { return this.catalogMap.get(id).price; }, this);
    var previousPackagingPrice = this.packagingPrice;
    var group = window.crypto && window.crypto.randomUUID ? window.crypto.randomUUID() : 'giftbox-' + Date.now().toString(36) + '-' + Math.random().toString(36).slice(2);
    var parentKey = null;
    var mutationStarted = false;
    var addedSuccessfully = false;
    var guardRefreshed = true;
    this.query('[data-cart-link]').hidden = true;
    this.setStatus(this.t('adding'));
    this.setBusy(true);
    try {
      // Re-read every catalogue page and cart quantity before reserving any items.
      var fresh = await Promise.all([this.fetchCatalog(), this.fetchPackaging(), this.requestJSON(this.root + 'cart.js')]);
      this.packagingPrice = Number(fresh[1].price);
      this.packagingAvailable = true;
      this.applyCatalog(fresh[0]);
      var stockErrors = validateStock(ids, fresh[0], fresh[2].items);
      if (stockErrors.length) {
        var stockError = new Error(stockErrors[0].code);
        stockError.values = { title: stockErrors[0].title, available: stockErrors[0].available };
        throw stockError;
      }
      if (this.packagingPrice !== previousPackagingPrice || ids.some(function (id, index) { return this.catalogMap.get(id).price !== previousPrices[index]; }, this)) throw new Error('price_changed');
      var properties = {
        _mirjo_giftbox_group: group,
        _mirjo_giftbox_role: 'packaging',
        _mirjo_giftbox_count: String(this.count),
        _mirjo_giftbox_title: personalisation.title,
        _mirjo_giftbox_color: personalisation.colour,
        _mirjo_giftbox_style: 'custom'
      };
      properties[this.t('property_samples')] = this.count + ' × 3 ml';
      properties[this.t('property_colour')] = this.t('colour_' + personalisation.colour);
      if (personalisation.title) properties[this.t('property_title')] = personalisation.title;
      if (personalisation.name) properties[this.t('property_subtitle')] = personalisation.name;
      if (personalisation.message) properties[this.t('property_message')] = personalisation.message;
      if (personalisation.backMessage) properties[this.t('property_back_message')] = personalisation.backMessage;
      mutationStarted = true;
      this.invalidateCartGuard();
      var parentResponse = await this.postJSON('cart/add.js', { items: [{ id: this.packagingId, quantity: 1, properties: properties }] });
      parentKey = parentResponse.items && parentResponse.items[0] && parentResponse.items[0].key;
      if (!parentKey) throw new Error('add_error');
      var selections = aggregateSelections(ids);
      var children = selections.map(function (selection) {
        var sampleProperties = { _mirjo_giftbox_group: group, _mirjo_giftbox_role: 'sample' };
        sampleProperties[this.t('property_giftbox')] = this.count + ' × 3 ml';
        return { id: selection.id, quantity: selection.quantity, parent_line_key: parentKey, properties: sampleProperties };
      }, this);
      await this.postJSON('cart/add.js', { items: children });
      var finalCart = await this.requestJSON(this.root + 'cart.js');
      if (!verifyGroup(finalCart.items, group, selections)) throw new Error('add_error');
      addedSuccessfully = true;
      this.setStatus(this.t('added'));
    } catch (error) {
      var failedRollback = false;
      if (mutationStarted) {
        try { await this.removeGroup(group, parentKey); } catch (cleanupError) { failedRollback = true; }
      }
      this.setStatus(this.t(failedRollback ? 'rollback_error' : (this.i18n[error.message] ? error.message : 'add_error'), error.values), true);
      this.query('[data-cart-link]').hidden = !failedRollback;
      if (error.message === 'box_unavailable') this.packagingAvailable = false;
    } finally {
      if (mutationStarted) {
        this.invalidateCartGuard();
        var guard = window.MirjoGiftboxCart;
        if (guard && typeof guard.refresh === 'function') {
          try { await guard.refresh(); } catch (refreshError) {
            guardRefreshed = false;
            var previousMessage = addedSuccessfully ? '' : this.query('[data-checkout-status]').textContent + ' ';
            this.setStatus(previousMessage + this.t('cart_refresh_error'), true);
            this.query('[data-cart-link]').hidden = false;
          }
        }
      }
      this.setBusy(false);
    }
    if (addedSuccessfully && guardRefreshed) window.location.assign(this.root + 'cart');
  };

  function initialise(root) {
    root.querySelectorAll('[data-mirjo-giftbox]').forEach(function (element) {
      if (element.dataset.giftboxInitialised) return;
      element.dataset.giftboxInitialised = 'true';
      try { new Giftbox(element); } catch (error) {
        var status = element.querySelector('[data-catalog-status]');
        if (status) status.setAttribute('role', 'alert');
      }
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initialise(document); });
  else initialise(document);
  document.addEventListener('shopify:section:load', function (event) { initialise(event.target); });
}());
